// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"07988ba3","845":"21f6436f"}[chunkId] + ".chunk.js";
};